import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {Router} from "@angular/router";
import {RemitaPaymentDto, RemittaModel} from "../models/remiteResponse.model";
import {ApiServiceService} from "./api-service.service";
import {AuthService} from "./auth.service";

@Injectable({
    providedIn: 'root',
})
export class RemitaPaymentService {

    remita: RemittaModel | any;
    paymentTransactionHistory: any;

    constructor(
      private apiService: ApiServiceService,
      private router: Router,
      private authenticationService: AuthService,
      ) {
    }

    get paymentInfo(): RemitaPaymentDto {
        let pi = sessionStorage.getItem("paymentInfo");
        let paymentInfo = JSON.parse(pi == null ? "{}" : pi);
        return paymentInfo;
    }

    generateRRR(request: RemitaPaymentDto | null): Observable<any> {
        const url = '/assessments/generate/rrr';
        this.apiService.suppressAlertError = true;
        return this.apiService.post(url, request);
    }

    acknowledgementRRR(rrr: any): Observable<any> {
        const url = "/api/payment/remita/payment/acknowledgement";
        return this.apiService.paymentPost_(url, rrr);
    }

    validatePayment(transactionId: string): Observable<any> {
        const url = "/assessments/remita/validate-transaction";
        return this.apiService.post(url, transactionId);
    }
    startInterswitchInline(request: RemitaPaymentDto | null): Observable<any> {
        if (request == null) {
            request = this.paymentInfo;
        }
        const url = '/assessments/interswitch/start-inline-payment';
        this.apiService.suppressAlertError = true;
        return this.apiService.post_(url, request);
    }

    startInterswitchAcknowledgement(response:any): Observable<any> {
        const url = '/assessments/interswitch/interswitch_acknowledge';
        this.apiService.suppressAlertError = true;
        return this.apiService.post_(url, response);
    }

    submitCredentials(request: RemitaPaymentDto){
      const rrrr = {

        fullName: this.authenticationService.getDisplayName,
        customerId: this.authenticationService.getTinNumber(),
        email: this.authenticationService.getEmail(),
        accessedBy:this.authenticationService.getUser().displayName,

        returnBackUrl : request.returnBackUrl,
        totalAmount : request.totalAmount,
      }
      sessionStorage.setItem('paymentInfo', JSON.stringify(rrrr));
      this.router.navigate(['/admin/payment']);
    }

    generateRemitaRRR(request: any | null): Observable<any> {
        const url = '/api/payment/remita/start-inline';
        this.apiService.suppressAlertError = true;
        return this.apiService.payment(url, request);
    }

}
